module.exports = __webpack_public_path__ + "nstatic/img/user-payment-success-logo.6ff816fa.png";